import { Text, Box, Icon } from '@chakra-ui/react';
import { ReactComponent as UsersIcon } from 'resources/images/users.svg';

export const EmptySuggestionList = () => {
  return (
    <Box data-testid="empty-suggestion-list" textAlign="center" pt="15%">
      <Icon as={UsersIcon} color="P.50" width={16} height={16} />
      <Text textAlign="center" mt={2} color="textBase">
        Search for collaborators <br /> or add an email to invite.
      </Text>
    </Box>
  );
};
